import { defineStore } from "pinia";
import Services from '@/services/sutting/townshipsServices'
import { mapList2Level, mapTownship } from '@/helpers/mapFuncs'

export const useTownshipsStore = defineStore("townships", {
persist: true,
state:()=>({
    township: {},
    townships: [],
}),
getters : {
    getTownship() {
        return mapTownship(this.township)
    },
    getTownships() {
        return this.townships.map(mapTownship)
    },
    getTownshipsList2Level() {
        return this.townships.map(mapList2Level)
    }
},
actions : {
    /** Start Sets */
    setTownship(township) {
        this.township = township
    },
    setTownships(townships) {
        this.townships = townships
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setTownship(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setTownships(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.townships.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.townships[this.townships.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.townships = this.townships.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
